module.exports = __webpack_public_path__ + "static/implementation-d6b7a03abd3c036596cf4d1866af1f26.png";